export var Namespace;
(function (Namespace) {
    Namespace["UNKNOWN_NAMESPACE"] = "UNKNOWN_NAMESPACE";
    Namespace["DOLLY"] = "DOLLY";
    Namespace["WISDOM"] = "WISDOM";
    Namespace["EDUCATION"] = "EDUCATION";
    Namespace["TEST"] = "TEST";
    Namespace["TEST_MSID"] = "TEST_MSID";
})(Namespace || (Namespace = {}));
export var Role;
(function (Role) {
    Role["UNKNOWN"] = "UNKNOWN";
    Role["USER"] = "USER";
    Role["ASSISTANT"] = "ASSISTANT";
})(Role || (Role = {}));
export var ChatMode;
(function (ChatMode) {
    ChatMode["UNKNOWN_CHAT_MODE"] = "UNKNOWN_CHAT_MODE";
    ChatMode["PREVIEW"] = "PREVIEW";
    ChatMode["PUBLISHED"] = "PUBLISHED";
    /** Pass the Chat Config on chat creation instead */
    ChatMode["LEARN"] = "LEARN";
})(ChatMode || (ChatMode = {}));
export var MessageType;
(function (MessageType) {
    MessageType["UNKNOWN_MESSAGE_TYPE"] = "UNKNOWN_MESSAGE_TYPE";
    MessageType["TEXT"] = "TEXT";
    MessageType["AUDIO"] = "AUDIO";
    MessageType["VIDEO"] = "VIDEO";
})(MessageType || (MessageType = {}));
export var VendorType;
(function (VendorType) {
    VendorType["UNKNOWN_VENDOR"] = "UNKNOWN_VENDOR";
    VendorType["TAVUS"] = "TAVUS";
    VendorType["ELEVENLABS"] = "ELEVENLABS";
    VendorType["HOURONE"] = "HOURONE";
    VendorType["ANAM"] = "ANAM";
})(VendorType || (VendorType = {}));
export var SourceType;
(function (SourceType) {
    SourceType["UNKNOWN_KNOWLEDGE_SOURCE"] = "UNKNOWN_KNOWLEDGE_SOURCE";
    SourceType["KNOWLEDGE_DOCUMENT"] = "KNOWLEDGE_DOCUMENT";
    SourceType["KNOWLEDGE_SNIPPET"] = "KNOWLEDGE_SNIPPET";
    SourceType["KNOWLEDGE_LINK"] = "KNOWLEDGE_LINK";
})(SourceType || (SourceType = {}));
export var VoiceSourcePolicy;
(function (VoiceSourcePolicy) {
    VoiceSourcePolicy["UNKNOWN_VOICE_SOURCE_POLICY"] = "UNKNOWN_VOICE_SOURCE_POLICY";
    /** Use persona-attached voice */
    VoiceSourcePolicy["PERSONA_VOICE"] = "PERSONA_VOICE";
    /** Use system-provided voice */
    VoiceSourcePolicy["SYSTEM_VOICE"] = "SYSTEM_VOICE";
})(VoiceSourcePolicy || (VoiceSourcePolicy = {}));
export var AvatarSourcePolicy;
(function (AvatarSourcePolicy) {
    AvatarSourcePolicy["UNKNOWN_AVATAR_SOURCE_POLICY"] = "UNKNOWN_AVATAR_SOURCE_POLICY";
    /** Use persona-attached avatar */
    AvatarSourcePolicy["PERSONA_AVATAR"] = "PERSONA_AVATAR";
    /** Use system-provided avatar */
    AvatarSourcePolicy["SYSTEM_AVATAR"] = "SYSTEM_AVATAR";
})(AvatarSourcePolicy || (AvatarSourcePolicy = {}));
/** The type of the limitation, e.g., minutes or seconds. */
export var Type;
(function (Type) {
    Type["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    Type["MINUTES"] = "MINUTES";
    Type["SECONDS"] = "SECONDS";
    Type["TOKENS"] = "TOKENS";
})(Type || (Type = {}));
export var VoiceVendor;
(function (VoiceVendor) {
    VoiceVendor["UNKNOWN_VOICE_VENDOR"] = "UNKNOWN_VOICE_VENDOR";
    VoiceVendor["ELEVEN_LABS"] = "ELEVEN_LABS";
    VoiceVendor["HOUR_ONE"] = "HOUR_ONE";
})(VoiceVendor || (VoiceVendor = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var Category;
(function (Category) {
    /** Default value. This value is unused. */
    Category["UNKNOWN_CATEGORY"] = "UNKNOWN_CATEGORY";
    /** General information about the persona */
    Category["GENERAL"] = "GENERAL";
    /** Identity-related information */
    Category["IDENTITY"] = "IDENTITY";
    /** Work and expertise information */
    Category["WORK_AND_EXPERTISE"] = "WORK_AND_EXPERTISE";
    /** Philosophy and worldview information */
    Category["PHILOSOPHY_AND_WORLDVIEW"] = "PHILOSOPHY_AND_WORLDVIEW";
    /** Relationship-related information */
    Category["RELATIONSHIPS"] = "RELATIONSHIPS";
    /** Personality traits and characteristics */
    Category["PERSONALITY"] = "PERSONALITY";
})(Category || (Category = {}));
export var Subcategory;
(function (Subcategory) {
    /** Default value. This value is unused. */
    Subcategory["UNKNOWN_SUBCATEGORY"] = "UNKNOWN_SUBCATEGORY";
    /** General - Personal information */
    Subcategory["GENERAL_PERSONAL"] = "GENERAL_PERSONAL";
    /** General - Lifestyle information */
    Subcategory["GENERAL_LIFESTYLE"] = "GENERAL_LIFESTYLE";
    /** General - Context information */
    Subcategory["GENERAL_CONTEXT"] = "GENERAL_CONTEXT";
    /** Identity - Professional information */
    Subcategory["IDENTITY_PROFESSIONAL"] = "IDENTITY_PROFESSIONAL";
    /** Identity - Background information */
    Subcategory["IDENTITY_BACKGROUND"] = "IDENTITY_BACKGROUND";
    /** Identity - Influences information */
    Subcategory["IDENTITY_INFLUENCES"] = "IDENTITY_INFLUENCES";
    /** Identity - Aspirations information */
    Subcategory["IDENTITY_ASPIRATIONS"] = "IDENTITY_ASPIRATIONS";
    /** Work and Expertise - Core expertise */
    Subcategory["EXPERTISE_CORE"] = "EXPERTISE_CORE";
    /** Work and Expertise - Methods and frameworks */
    Subcategory["EXPERTISE_METHODS"] = "EXPERTISE_METHODS";
    /** Work and Expertise - Industry knowledge */
    Subcategory["EXPERTISE_INDUSTRY"] = "EXPERTISE_INDUSTRY";
    /** Work and Expertise - Current work */
    Subcategory["WORK_CURRENT"] = "WORK_CURRENT";
    /** Philosophy and Worldview - Core values */
    Subcategory["PHILOSOPHY_CORE"] = "PHILOSOPHY_CORE";
    /** Philosophy and Worldview - Success and learning */
    Subcategory["PHILOSOPHY_SUCCESS"] = "PHILOSOPHY_SUCCESS";
    /** Philosophy and Worldview - Work philosophy */
    Subcategory["PHILOSOPHY_WORK"] = "PHILOSOPHY_WORK";
    /** Relationships - Communication style */
    Subcategory["RELATIONSHIPS_COMMUNICATION"] = "RELATIONSHIPS_COMMUNICATION";
    /** Relationships - Leadership approach */
    Subcategory["RELATIONSHIPS_LEADERSHIP"] = "RELATIONSHIPS_LEADERSHIP";
    /** Relationships - External interactions */
    Subcategory["RELATIONSHIPS_EXTERNAL"] = "RELATIONSHIPS_EXTERNAL";
    /** Relationships - Teaching style */
    Subcategory["RELATIONSHIPS_TEACHING"] = "RELATIONSHIPS_TEACHING";
    /** Personality - Core traits */
    Subcategory["PERSONALITY_TRAITS"] = "PERSONALITY_TRAITS";
    /** Personality - Behavioral patterns */
    Subcategory["PERSONALITY_BEHAVIOR"] = "PERSONALITY_BEHAVIOR";
    /** Personality - Stress and conflict responses */
    Subcategory["PERSONALITY_STRESS"] = "PERSONALITY_STRESS";
    /** Personality - Work-related personality */
    Subcategory["PERSONALITY_WORK"] = "PERSONALITY_WORK";
    /** Personality - Adaptation and change */
    Subcategory["PERSONALITY_ADAPTATION"] = "PERSONALITY_ADAPTATION";
})(Subcategory || (Subcategory = {}));
/** UpdateType enum represents the type of the last update made to the KnowledgeSnippet. */
export var UpdateType;
(function (UpdateType) {
    /** Unknown update type, used as a default value. */
    UpdateType["UNKNOWN_UPDATE_TYPE"] = "UNKNOWN_UPDATE_TYPE";
    /** Manual update by owner. */
    UpdateType["MANUAL"] = "MANUAL";
    /** AI-generated update, indicating that the content was modified by an AI system. */
    UpdateType["AI"] = "AI";
})(UpdateType || (UpdateType = {}));
export var State;
(function (State) {
    /** Default value. This value is unused. */
    State["UNKNOWN_STATE"] = "UNKNOWN_STATE";
    /** Newly created snippet */
    State["NEW"] = "NEW";
    /** Published and visible snippet */
    State["PUBLISHED"] = "PUBLISHED";
    /** Modified snippet */
    State["MODIFIED"] = "MODIFIED";
    /** Deleted snippet */
    State["DELETED"] = "DELETED";
})(State || (State = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map